import { Box, Button, Divider, FormGroup, Typography } from "@material-ui/core"

import { ReactComponent as CloseButton } from "assets/icons8-close.svg"
import { drillDownStyles, standardScrollBar } from "../../styles"

import { useI18n } from "providers/I18n"
import { getPalette } from "../Charts/palette"
import { LegendItemAllCheckbox } from "./LegendItemAllCheckbox"
import { LegendItemCheckbox } from "./LegendItemCheckbox"
import { cx } from "@emotion/css"
import { useWindowDimensions } from "../../hooks/useWindowDimensions"

export default function LegendItemsBox({
  itemKey,
  legendItems,
  itemIndex,
  availableEntities,
  handleChangeAvailableEntities,
  handleCheckAllEntities,
  handleOpen,
  isExpanded,
  checked,
  hasFiltersScroll,
}: {
  itemKey: string
  legendItems: string[]
  itemIndex: number
  availableEntities: string[][]
  handleChangeAvailableEntities: (idx: number, entity: string) => void
  handleCheckAllEntities: (idx: number, items: string[]) => void
  handleOpen: React.MouseEventHandler<HTMLButtonElement>
  isExpanded?: boolean
  checked: boolean
  hasFiltersScroll: boolean
}) {
  const { t } = useI18n()

  const dimension = useWindowDimensions()

  return (
    <Box
      display="flex"
      flexDirection="column"
      style={{
        width: 300,
        height: "100%",
        backgroundColor: "var(--extra-dark-grey)",
        borderRadius: "16px",
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        padding={hasFiltersScroll ? "12px 26px 12px 20px" : "12px 20px"}
      >
        <Typography
          align="left"
          className={drillDownStyles.drillDownTitle}
          style={{
            fontSize: "12px",
            fontWeight: 400,
          }}
        >
          {t("revenue.select")} {itemKey[0].toUpperCase() + itemKey.slice(1)}
        </Typography>
        {!isExpanded && (
          <Button
            style={{ color: "var(--white)", padding: 0, minWidth: 0 }}
            onClick={handleOpen}
          >
            <CloseButton />
          </Button>
        )}
      </Box>
      <Divider style={{ backgroundColor: "var(--black)" }} />

      <FormGroup
        style={{
          padding: hasFiltersScroll
            ? "12px 7px 12px 20px"
            : isExpanded
              ? "12px 12px 12px 20px"
              : "12px 16px 12px 20px",
        }}
      >
        <div style={{ marginRight: hasFiltersScroll ? "14px" : 0 }}>
          <LegendItemAllCheckbox
            keyIndex={itemIndex}
            checked={checked}
            onChange={handleCheckAllEntities}
            legendItems={legendItems}
          />
        </div>
        <div
          id="divScroll"
          style={{
            height: "100%",
            maxHeight: isExpanded
              ? dimension.height * (dimension.height < 950 ? 0.588 : 0.605)
              : 569,
            overflowY: "auto",
          }}
          className={hasFiltersScroll ? cx(standardScrollBar.root) : ""}
        >
          {legendItems.map((item, index) => (
            <div
              style={{
                marginRight: hasFiltersScroll ? "8.4px" : 0,
              }}
            >
              <LegendItemCheckbox
                key={index}
                keyIndex={itemIndex}
                value={item}
                color={getPalette(itemKey)[index]}
                onChange={handleChangeAvailableEntities}
                availableEntities={availableEntities[itemIndex]}
              />
            </div>
          ))}
        </div>
      </FormGroup>
    </Box>
  )
}
